import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import createUUID from '../../../../util/create-uuid'


export const findEmailTemplateListRequest = () => ({
    type: type.FIND_EMAIL_TEMPLATE_LIST_REQUEST,
})

export const findTemplateListSuccess = (emailTemplateList) => ({
    type: type.FIND_EMAIL_TEMPLATE_LIST_SUCCESS,
    payload: {
        emailTemplateList,
    },
})

export const findEmailTemplateListError = (error) => ({
    type: type.FIND_EMAIL_TEMPLATE_LIST_ERROR,
    payload: {
        error,
    },
})

export const findEmailTemplateList = () => (dispatch, getState) => {
    dispatch(findEmailTemplateListRequest())

    get('/api/email/template/find-all')
        .then(emailTemplateList => {
            dispatch(findTemplateListSuccess(emailTemplateList))
        })
        .catch(error => {
            dispatch(findEmailTemplateListError(error))
        })
}

export const changeProcess = (name, value) => ({
    type: type.CHANGE_PROCESS,
    payload: {
        name,
        value,
    },
})

export const changeLocale = (name, locale) => ({
    type: type.CHANGE_LOCALE,
    payload: {
        locale,
    },
})


export const findEmailTemplateByIdRequest = (emailTemplateId) => ({
    type: type.FIND_EMAIL_TEMPLATE_BY_ID_REQUEST,
    payload: {
        emailTemplateId,
    },
})

export const findEmailTemplateByIdSuccess = (emailTemplate) => ({
    type: type.FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS,
    payload: {
        emailTemplate,
    },
})

export const findEmailTemplateByIdError = (error) => ({
    type: type.FIND_EMAIL_TEMPLATE_BY_ID_ERROR,
    payload: {
        error,
    },
})

export const findEmailTemplateById = (name, emailTemplateId) => (dispatch, getState) => {
    dispatch(findEmailTemplateByIdRequest(emailTemplateId))

    if (!emailTemplateId) {
        return
    }

    get('/api/email/template/find-by-id?emailTemplateId=' + emailTemplateId)
        .then(emailTemplate => {
            emailTemplate.templateVariantList.forEach(emailTemplateVariant => {
                emailTemplateVariant.localId = createUUID()
            })

            dispatch(findEmailTemplateByIdSuccess(emailTemplate))
        })
        .catch(error => {
            dispatch(findEmailTemplateByIdError(error))
        })
}


export const changeEmailTemplateVariant = (localId, name, value) => ({
    type: type.CHANGE_EMAIL_TEMPLATE_VARIANT,
    payload: {
        localId,
        name,
        value,
    },
})

export const createEmailTemplateVariant = () => ({
    type: type.CREATE_EMAIL_TEMPLATE_VARIANT,
})

export const testEmailTemplateVariant = (localId) => (dispatch, getState) => {
    const state = getState()
    const emailTemplateVariantId = selector.selectEmailTemplateVariantIdByLocalId(state, localId)
    if (!emailTemplateVariantId) {
        return
    }
    get('/api/email/template-variant/test?emailTemplateVariantId=' + emailTemplateVariantId)
}


export const saveEmailTemplateVariantRequest = () => ({
    type: type.SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST,
})

export const saveEmailTemplateVariantSuccess = (localId, emailTemplateVariant) => ({
    type: type.SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS,
    payload: {
        localId,
        emailTemplateVariant,
    },
})

export const saveEmailTemplateVariantError = (error) => ({
    type: type.SAVE_EMAIL_TEMPLATE_VARIANT_ERROR,
    payload: {
        error,
    },
})

export const saveEmailTemplateVariant = (localId) => (dispatch, getState) => {
    const state = getState()
    const variant = selector.selectEmailTemplateVariantByLocalId(state, localId)
    if (variant === null) {
        return
    }
    dispatch(saveEmailTemplateVariantRequest())
    post('/api/email/template-variant/save', variant)
        .then(emailTemplateVariant => {
            emailTemplateVariant.localId = localId
            dispatch(saveEmailTemplateVariantSuccess(localId, emailTemplateVariant))
        })
        .catch(error => {
            dispatch(saveEmailTemplateVariantError(error))
        })
}


export const deleteEmailTemplateVariantRequest = (localId) => ({
    type: type.DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST,
    payload: {
        localId,
    },
})

export const deleteEmailTemplateVariantSuccess = () => ({
    type: type.DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS,
})

export const deleteEmailTemplateVariantError = (error) => ({
    type: type.DELETE_EMAIL_TEMPLATE_VARIANT_ERROR,
    payload: {
        error,
    },
})

export const deleteEmailTemplateVariant = (localId) => (dispatch, getState) => {
    const state = getState()
    const variant = selector.selectEmailTemplateVariantByLocalId(state, localId)

    dispatch(deleteEmailTemplateVariantRequest(localId))
    if (!variant || !variant.id) {
        return
    }

    get('/api/email/template-variant/delete?emailTemplateVariantId=' + variant.id)
        .then(() => {
            dispatch(deleteEmailTemplateVariantSuccess())
        })
        .catch(error => {
            dispatch(deleteEmailTemplateVariantError(error))
        })
}


export const getProcessMacroListRequest = () => ({
    type: type.GET_PROCESS_MACRO_LIST_REQUEST,
})

export const getProcessMacroListSuccess = (processName, emailMacroList) => ({
    type: type.GET_PROCESS_MACRO_LIST_SUCCESS,
    payload: {
        processName,
        emailMacroList,
    },
})

export const getProcessMacroListError = (error) => ({
    type: type.GET_PROCESS_MACRO_LIST_ERROR,
    payload: {
        error,
    },
})

export const getProcessMacroList = () => (dispatch, getState) => {
    const state = getState()
    const processMacroList = selector.selectProcessMacroListForCurrentProcess(state)
    if (processMacroList) {
        return
    }
    const currentProcessName = selector.selectUserSelectionProcess(state)
    if (!currentProcessName) {
        return
    }

    dispatch(getProcessMacroListRequest())

    get('/api/sales-order/get-salesorder-macro-list?processName=' + currentProcessName)
        .then((emailMacroList) => {
            dispatch(getProcessMacroListSuccess(currentProcessName, emailMacroList))
        })
        .catch(error => {
            dispatch(getProcessMacroListError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/email/state/manage/action.js